export default __webpack_public_path__ + "static/media/tool-icon-shirt-blue-05.ce39bd32.svg";